import { ENQUIRY_STATUSES, APPLICATION_STATUSES, MESSAGE_STATUSES, SERVICE_CATEGORIES, CORE_CATEGORIES, CONTACT_TOPICS } from "../../data/options";

export const ADMIN_KINDS = {
  enquiries: {
    label: "Business Requests",
    singular: "Business request",
    statuses: ENQUIRY_STATUSES,
    categories: SERVICE_CATEGORIES,
    categoryLabel: "Service",
    columns: [["company", "Company"], ["service_category", "Service"], ["country", "Country"]],
    fields: [["full_name", "Full name"], ["email", "Business email"], ["company", "Company"], ["job_title", "Job title"], ["country", "Country / primary jurisdiction"], ["industry", "Industry"], ["service_category", "Service category"], ["start_date", "Desired start date"], ["duration", "Expected duration"], ["jurisdictions", "Relevant jurisdictions"], ["budget", "Indicative budget"], ["preferred_contact", "Preferred contact"], ["phone", "Phone"], ["marketing_consent", "Marketing consent"], ["privacy_ack", "Privacy acknowledged"], ["description", "Requirement", true]],
  },
  applications: {
    label: "Expert Applications",
    singular: "Expert application",
    statuses: APPLICATION_STATUSES,
    categories: CORE_CATEGORIES,
    categoryLabel: "Category",
    columns: [["primary_category", "Category"], ["years_experience", "Years"], ["country_residence", "Country"]],
    fields: [["full_name", "Full name"], ["email", "Professional email"], ["country_residence", "Country of residence"], ["jurisdictions", "Qualified jurisdictions"], ["primary_category", "Primary category"], ["years_experience", "Years of experience"], ["affiliation", "Current affiliation"], ["industries", "Industries served"], ["availability", "Availability"], ["engagement_types", "Preferred engagement types"], ["profile_url", "LinkedIn / website"], ["registration_details", "Registration details"], ["privacy_consent", "Privacy consent"], ["accuracy_declaration", "Accuracy declaration"], ["profile_public", "Public profile enabled"], ["specialisations", "Areas of specialisation", true], ["qualifications", "Qualifications and certifications", true]],
  },
  messages: {
    label: "Contact Messages",
    singular: "Contact message",
    statuses: MESSAGE_STATUSES,
    categories: CONTACT_TOPICS,
    categoryLabel: "Topic",
    columns: [["organisation", "Organisation"], ["topic", "Topic"], ["subject", "Subject"]],
    fields: [["full_name", "Full name"], ["email", "Email"], ["organisation", "Organisation"], ["topic", "Topic"], ["subject", "Subject"], ["privacy_ack", "Privacy acknowledged"], ["message", "Message", true]],
  },
};

const TONES = {
  New: "bg-blue-50 text-blue-700 border-blue-200", Received: "bg-blue-50 text-blue-700 border-blue-200",
  Approved: "bg-emerald-50 text-emerald-700 border-emerald-200", Closed: "bg-slate-100 text-slate-600 border-slate-200",
  Declined: "bg-rose-50 text-rose-700 border-rose-200", Responded: "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Clarification Required": "bg-amber-50 text-amber-800 border-amber-200", "Information Required": "bg-amber-50 text-amber-800 border-amber-200",
};

export const StatusBadge = ({ status }) => (
  <span className={`inline-flex whitespace-nowrap rounded-sm border px-2 py-0.5 text-[11px] font-semibold ${TONES[status] || "bg-indigo-50 text-indigo-700 border-indigo-200"}`} data-testid="status-badge">{status}</span>
);

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" }) : "—");

export const fmtValue = (v) => {
  if (v === true) return "Yes";
  if (v === false) return "No";
  if (Array.isArray(v)) return v.join(", ") || "—";
  return v === null || v === undefined || v === "" ? "—" : String(v);
};

export const downloadBlob = (data, filename) => {
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
